import { type PrimitiveProps } from '@react-three/fiber';
import { type OP1Model, GLTFModel } from '@billykwok/3d';

import { AnimatedPrimitive } from '@/utils/react-three-fiber/animations';
import { useGLTF } from '@/utils/react-three-fiber/useGLTF';

const modelPath = `/models/${GLTFModel.OP1}`;

export function AnimatedOP1(props: Partial<PrimitiveProps>) {
  const { scene } = useGLTF<OP1Model, string>(modelPath);
  return <AnimatedPrimitive object={scene} dispose={null} {...props} />;
}

useGLTF.preload(modelPath);
